import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import TableComponent from 'UiKit/table-component';

import { TableSkeleton } from 'View/report-attendance/component/skeleton';
import { tableListHost, tableListOperator } from 'View/report-attendance/section/table/const';
import { useReportAttendanceState } from 'View/report-attendance/state';

import styles from './styles.module.css';

const Table = ({ data, isFetching, t }) => {
  const { filterState, updateFilterState, selectedTab } = useReportAttendanceState();

  const onChangePagination = (page) => updateFilterState({ page });

  const isOperatorTab = selectedTab === 'operator';

  const tableList = isOperatorTab ? tableListOperator : tableListHost({ t });

  return (
    <Box className={styles['table__container']}>
      <Box className={styles['table__wrapper']}>
        <Condition statement={!isFetching} fallback={<TableSkeleton />}>
          <TableComponent
            tableName="table__report-attendance"
            columns={tableList}
            dataSource={data?.reports || []}
            isDataExist={data?.isDataExist}
            verticalAlignBody={isOperatorTab ? 'middle' : 'top'}
            paddingBodyBox={isOperatorTab ? '0 12px' : '0px'}
            rowHeight={isOperatorTab ? '64px' : '100%'}
            maxTableHeight="calc(100vh - 355px)"
            maxTableBodyHeight="calc(100vh - 444px)"
            tableComponentHeight="calc(100vh - 286px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalCount,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Condition>
      </Box>
    </Box>
  );
};

export default Table;
